import { render, staticRenderFns } from "./PinPosts.vue?vue&type=template&id=3ebeb973&scoped=true&"
import script from "./PinPosts.vue?vue&type=script&lang=js&"
export * from "./PinPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebeb973",
  null
  
)

export default component.exports